export default "__VITE_ASSET__8ca06215__"